import { useEffect, useState } from 'react';
import {
  detectNativePlatform,
  isNativeShellSync,
} from '../adapters/device/platformDetector';

/** True on iOS/Android Capacitor shells (YouTube should open the app, not an iframe). */
export function useIsNativeShell(): boolean {
  const [native, setNative] = useState(isNativeShellSync);
  useEffect(() => {
    let cancelled = false;
    void detectNativePlatform().then((platform) => {
      if (!cancelled) setNative(platform === 'ios' || platform === 'android');
    });
    return () => {
      cancelled = true;
    };
  }, []);
  return native;
}
